import React from 'react';

import { ISCPlayerViewer } from './isc-player-viewer/isc-player-viewer';
import { LessonPlayerViewer } from './lesson-player-viewer/lesson-player-viewer';
import { PlayerViewerType } from './player-viewer-type.enum';
import type { NavHeader } from '../../interfaces/nav-header';

interface PlayerViewerSelectorProps {
  type: PlayerViewerType;
  slides: any[];
  navHeader?: NavHeader;
}

export function PlayerViewerSelector({
  type,
  slides,
  navHeader,
}: PlayerViewerSelectorProps) {
  switch (type) {
    case PlayerViewerType.ISC:
      return <ISCPlayerViewer originalSlides={slides} />;
    case PlayerViewerType.LESSON:
      return (
        <LessonPlayerViewer originalSlides={slides} navHeader={navHeader} />
      );
    default:
      return <ISCPlayerViewer originalSlides={slides} />;
  }
}
